import { Box, styled } from '@mui/material';

export const StyledMainBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  margin: theme.spacing(2, 2, 0, 2)
}));
